import { useCallback, useState } from "react";

export const useDrawingArrow = (props: { defaultColor: string; loginUserCompanyId?: number }) => {
  const [isDrawing, setIsDrawing] = useState<boolean>(false);
  const [companyId, setCompanyId] = useState<number>(props.loginUserCompanyId);
  const [color, setColor] = useState<string>(props.defaultColor);
  const [thickness, setThickness] = useState<number>(5);
  const [useStartHour, setUseStartHour] = useState<string>();
  const [useEndHour, setUseEndHour] = useState<string>();
  const [coords, setCoords] = useState<[number, number][]>([]);

  const init = useCallback(() => {
    setIsDrawing(true);
    setCompanyId(props.loginUserCompanyId);
    setColor(props.defaultColor);
    setThickness(5);
    setUseStartHour(undefined);
    setUseEndHour(undefined);
    setCoords([]);
  }, [props.defaultColor]);

  const end = useCallback(() => {
    setIsDrawing(false);
  }, []);

  const update = useCallback(
    (arrow: {
      company_id: number;
      color: string;
      thickness: number;
      use_start_hour?: string;
      use_end_hour?: string;
    }) => {
      setCompanyId(arrow.company_id);
      setColor(arrow.color);
      setThickness(arrow.thickness);
      setUseStartHour(arrow.use_start_hour);
      setUseEndHour(arrow.use_end_hour);
    },
    []
  );

  const addCoord = useCallback(
    (coord: [number, number]) => {
      setCoords([...coords, coord]);
    },
    [coords]
  );

  return {
    init,
    end,
    isDrawing,
    companyId,
    color,
    thickness,
    useStartHour,
    useEndHour,
    coords,
    update,
    addCoord,
  };
};
